import { useMutation } from "react-fetching-library";

export function useApiMutation(action) {
  const mutationResult = useMutation(action);
  return mutationResult;
}
